import React from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Link, Stack, Typography } from '@mui/material'
import SignUpForm from './components/SignUpForm'
import { Helmet } from 'react-helmet-async'
import { Box } from '@mui/system'
import { GoogleLogin } from '@react-oauth/google'
import { useAuth } from '../../hooks/useAuth'

export const SignUp = () => {
  const { t } = useTranslation()
  const { signWithGoogleToken } = useAuth()

  return (
    <Stack>
      <Helmet>
        <title> Create Account | DWF </title>
      </Helmet>
      <Box>
        <GoogleLogin
          width='2000'
          text='signin_with'
          onSuccess={async (credentialResponse: any) => {
            console.log(credentialResponse.credential)
            await signWithGoogleToken(credentialResponse.credential)
          }}
          onError={() => {
            console.log('Login Failed')
          }}
        />
      </Box>
      <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('general.or')}
        </Typography>
      </Divider>
      <SignUpForm/>
      <Stack alignItems="center" sx={{ mt: '10px' }}>
        <Typography>{`${t('signUp.link.alreadyHaveAccount')} `}
          <Link variant="subtitle2" href="/signIn">{t('signUp.link.signIn')}</Link>
        </Typography>
      </Stack>
    </Stack>
  )
}
